var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.33366H17.5M5.83333 12.5003H6.66667M10 12.5003H10.8333M5 15.8337H15C15.663 15.8337 16.2989 15.5703 16.7678 15.1014C17.2366 14.6326 17.5 13.9967 17.5 13.3337V6.66699C17.5 6.00395 17.2366 5.36807 16.7678 4.89923C16.2989 4.43038 15.663 4.16699 15 4.16699H5C4.33696 4.16699 3.70107 4.43038 3.23223 4.89923C2.76339 5.36807 2.5 6.00395 2.5 6.66699V13.3337C2.5 13.9967 2.76339 14.6326 3.23223 15.1014C3.70107 15.5703 4.33696 15.8337 5 15.8337Z",
    stroke: "#717171",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.cd8a9216cf6f28b7691d42d177a26e44.svg";
export { ForwardRef as ReactComponent };